import { z } from "zod";
import { customErrorMap } from "../shared/validation/zod";
import { PaginatedSchema } from "@shared/api/pagination";

z.setErrorMap(customErrorMap);


export const ItemEntrySchema = z.object({

    // required
    id: z.number(),
    business_id: z.number(),
    item_id: z.number(),
    sku: z.string().min(1),
    out: z.number(),
    in: z.number(),
    balance: z.number(),
    price: z.coerce.number(),
    account_name: z.string(),
    account_number: z.number(),

    created_at: z.string(),
    updated_at: z.string(), 
    
});

export const ItemEntrySearchSchema = z.object({
    item_id: z.number().optional(),
});

export const ItemEntriesPaginatedSchema = PaginatedSchema(ItemEntrySchema);

export type ItemEntry = z.infer<typeof ItemEntrySchema>
export type ItemEntrySearch = z.infer<typeof ItemEntrySearchSchema>
export type SearchItemEntriesBrowseResponse = z.infer<typeof ItemEntriesPaginatedSchema>
